export default "__VITE_ASSET__de726093__"